module.exports = __webpack_public_path__ + "static/img/banner_数据智能体.b06b3006.png";